import { FaCar, FaDollarSign, FaTools, FaStar, FaRoad, FaShieldAlt, FaUsers, FaBriefcase, FaHeart, FaThumbsUp, FaHandshake, FaCogs } from "react-icons/fa";
import { images } from ".";

const MissionValue = {
    sub: "Driving Your Success",
    heading: "Mission & Values",
    sections: [
        {
            id: "mission",
            title: "Our Mission",
            heading: "Your Trusted Automotive Partner",
            description: "We are committed to offering quality vehicles and exceptional services to make your car-buying experience seamless and enjoyable.",
            points: [
                { icon: <FaCar />, title: "Wide Range of Vehicles" },
                { icon: <FaDollarSign />, title: "Flexible Financing Options" },
                { icon: <FaTools />, title: "Expert Maintenance Services" },
                { icon: <FaStar />, title: "Customer-Centric Approach" },
                { icon: <FaRoad />, title: "Test Drive Convenience" }
            ],
            image: images.mission,
        },
        {
            id: "vision",
            title: "Our Vision",
            heading: "Your Trusted Partner in Automotive Excellence",
            description: "Our vision is to be the leading provider of quality vehicles and exceptional services, ensuring a seamless car-buying experience.",
            points: [
                { icon: <FaShieldAlt />, title: "Comprehensive Vehicle Selection" },
                { icon: <FaDollarSign />, title: "Affordable Financing Plans" },
                { icon: <FaUsers />, title: "Exceptional Customer Support" },
                { icon: <FaBriefcase />, title: "Professional Sales Team" },
                { icon: <FaHeart />, title: "Commitment to Quality" }
            ],
            image: images.vision,
        },
        {
            id: "values",
            title: "Our Values",
            heading: "Core Values that Drive Our Success",
            description: "We uphold integrity, innovation, and excellence in every interaction to provide superior customer satisfaction.",
            points: [
                { icon: <FaThumbsUp />, title: "Customer-Centric Approach" },
                { icon: <FaHandshake />, title: "Integrity and Transparency" },
                { icon: <FaCogs />, title: "Innovation and Progress" },
                { icon: <FaHeart />, title: "Passion for Excellence" },
                { icon: <FaUsers />, title: "Teamwork and Collaboration" }
            ],
            image: images.values,
        }
    ],
}

export default MissionValue;